import {Box, styled} from "@mui/material";
import {green} from "@mui/material/colors";

const ProgressLine = (props) => {

    const {percent = 0, isCompleted, className, ...restProps} = props;

    return (
        <Root {...restProps} className={isCompleted ? "Mui-completed" : ""} width={percent}></Root>
    )
}
export default ProgressLine;

const Root = styled(Box)(({theme, width}) => ({
    position: "relative",
    width: "100%",
    height: 8,
    borderRadius: 16,
    "&:before": {
        content: "''",
        width: `${width}%`,
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        backgroundColor: theme.palette.primary.main,
        borderRadius: "inherit",
        transition: "width .2s ease-in-out"
    },
    background: theme.palette.primary.light,
    "&.Mui-completed": {
        background: green[500],
        "&:before": {display: "none"}
    }
}));
